import axios from '@/utils/request/index.js'

const loginUrl = '/sso/user/login'
const enterUrl = '/sso/user/enter'
const individualInfoUrl = '/sso/user/get'
const registeredSmsUrl = '/base/message/register'
const registeredUrl = '/sso/user/register'
const registeredLawOfficeUrl = '/sso/user/registerLawOrg'
const findPwdUrl = '/sso/user/findPwd'
const cListRoleListUrl = '/sso/role/cList' // 无角色选择角色列表

const login = async (body) => {
  try {
    const { data } = await axios.post(loginUrl, {
      ...body,
    })
    return data.data
  } catch (error) {

    throw error
  }
}

const enter = async (body) => {
  try {
    const { data } = await axios.post(enterUrl, {
      ...body,
    })
    return data.data
  } catch (error) {

    throw error
  }
}

const individualInfo = async (body) => {
  try {
    const { data } = await axios.post(individualInfoUrl, {
      ...body,
    })
    return data.data
  } catch (error) {

    throw error
  }
}

const registeredSms = async (body) => {
  try {
    const { data } = await axios.post(registeredSmsUrl, {
      ...body,
    })
    return data
  } catch (error) {

    throw error
  }
}

const registeredLawOffice = async (body) => {
  try {
    const { data } = await axios.post(registeredLawOfficeUrl, {
      ...body,
    })
    return data.data
  } catch (error) {

    throw error
  }
}

const registered = async (body) => {
  try {
    const { data } = await axios.post(registeredUrl, {
      ...body,
    })
    return data.data
  } catch (error) {

    throw error
  }
}

const findPwd = async (body) => {
  try {
    const { data } = await axios.post(findPwdUrl, {
      ...body,
    })
    return data.data
  } catch (error) {

    throw error
  }
}

const cListRoleList = async (body) => {
  try {
    const { data } = await axios.post(cListRoleListUrl, {
      ...body,
    })
    return data.data
  } catch (error) {

    throw error
  }
}

const infoUrl = '/sso/user/flush'
const info = async (body) => {
  try {
    const { data } = await axios.post(infoUrl, {
      ...body,
    })
    return data.data
  } catch (error) {

    throw error
  }
}

export default {
  login,
  enter,
  individualInfo,
  registeredSms,
  registered,
  findPwd,
  registeredLawOffice,
  cListRoleList,
  info,
  loginUrl,
  enterUrl,
  individualInfoUrl,
  registeredSmsUrl,
  registeredUrl,
  findPwdUrl,
  registeredLawOfficeUrl,
  cListRoleListUrl,
  infoUrl,
}